import axios from "axios";
import UserService from "rc-app/services/UserService";

export const getMatterports = async (projectId, page = 0, limit = 20) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/views/matterport?project_id=${projectId}&page=${page}&limit=${limit}`;

    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching matterports:", error);
    throw error;
  }
};

export const updateMatterport = async (matterportId, jsonData) => {
  try {
    console.log("update Matterport", matterportId, jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/matterport/${matterportId}`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.put(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error updating matterport:", error);
    throw error;
  }
};

export const deleteMatterport = async (matterportId) => {
  try {
    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/matterport/${matterportId}`;

    const response = await axios.put(API_URL, { is_active: false }, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting matterport:", error);
    throw error;
  }
};

export const createMatterport = async (jsonData) => {
  try {
    console.log("create Matterport", jsonData);

    const API_URL = `${process.env.REACT_APP_ONEVERSE_REALESTATE_SERVER_URL}/api/v1/realestate/actions/matterport`;
    const PAYLOAD = {
      ...jsonData,
    };

    const response = await axios.post(API_URL, PAYLOAD, {
      headers: {
        Authorization: `Bearer ${UserService.getToken()}`,
        "ngrok-skip-browser-warning": "disabled",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating matterport:", error);
    throw error;
  }
};
